import clsx from 'clsx';

import PropTypes from 'prop-types';

import { DEFAULT_POST_CONFIG } from '@/lib/posts/defaultPostConfig';
import { getPostType, LI_POST_TYPES, STORY } from '@/lib/posts/postTypes';
//lib
import { TIKTOK_BUSINESS } from '@/lib/socialProfile';

//components
import Post from '@/components/base/Post';
import HoverLabelAndAlbums from '@/components/base/Post/HoverLabelAndAlbums';

const TiktokPost = ({
    data,
    isLoading,
    config = undefined,
    openViewer = undefined,
    isExport = false,
    handleLabelsEvent = undefined,
    handleAlbumsEvent = undefined,
    postConfig = { hasHover: true, hasFooter: true, showLabels: true, showAlbums: true },
    showHeader = true,
    ...restProps
}) => {
    const type = getPostType({ network: TIKTOK_BUSINESS, type: data?.type });
    const mergedPostConfig = { ...DEFAULT_POST_CONFIG, ...postConfig };

    if (isLoading) {
        return <Post.Placeholder postType={STORY} isExport={isExport} />;
    }

    return (
        <div className="w-full">
            {showHeader && <Post.Header data={data} isExport={isExport} />}
            <Post
                data={data}
                config={config}
                isLoading={isLoading}
                className={clsx('w-full bg-white', {
                    'p-0.5': !mergedPostConfig?.hasFooter,
                    'px-2 pt-2': mergedPostConfig?.hasFooter,
                    'dark:bg-icoDarkMode-anthracite': !isExport
                })}
                isExport={isExport}
                {...restProps}>
                {({ referenceElement }) => (
                    <>
                        <Post.Content className="w-full">
                            {mergedPostConfig?.hasHover ? (
                                <HoverLabelAndAlbums
                                    openViewer={openViewer}
                                    referenceElement={referenceElement}
                                    handleLabelsEvent={handleLabelsEvent}
                                    handleAlbumsEvent={handleAlbumsEvent}
                                    showLabels={mergedPostConfig?.showLabels}
                                    showAlbums={mergedPostConfig?.showAlbums}
                                    socialProfile={data?.social_profile}
                                />
                            ) : null}
                            {type && type !== LI_POST_TYPES.TYPE_STATUS ? (
                                <Post.PostTypeIcon
                                    type={type === LI_POST_TYPES.TYPE_PHOTO ? 'content' : type}
                                    isExport={isExport}
                                />
                            ) : null}
                            {data?.promoted_post ? (
                                <div className="absolute left-1 top-1 flex flex-col space-y-1.5">
                                    <Post.Promoted />
                                </div>
                            ) : null}
                            <div className={config?.forceSquareFormat ? 'square' : 'story'}>
                                <Post.Image />
                            </div>
                        </Post.Content>
                        {mergedPostConfig?.hasFooter ? <Post.Footer type={type} /> : null}
                    </>
                )}
            </Post>
        </div>
    );
};

TiktokPost.propTypes = {
    data: PropTypes.object,
    isLoading: PropTypes.bool,
    config: PropTypes.object,
    openViewer: PropTypes.func,
    addLabel: PropTypes.func,
    addAlbum: PropTypes.func,
    isExport: PropTypes.bool,
    handleLabelsEvent: PropTypes.func,
    handleAlbumsEvent: PropTypes.func,
    postConfig: PropTypes.object,
    showHeader: PropTypes.bool
};

export default TiktokPost;
